export const unique = <T>(array: T[]) => Array.from(new Set(array))
